import { api } from "../../api/axios";
import type {
  TWebinarRequest,
  TUserWebinar,
  TUserWebinarsResponse,
  TWebinarAccessStatus,
} from "../types";

export const getWebinar = async (params: TWebinarRequest["payload"]) => {
  const { data } = await api.post<TWebinarRequest["response"]>(
    "/v1/users/me/webinars/enroll",
    {
      webinarId: params.webinarId,
    }
  );
  return data;
};

export const getUserWebinars = async () => {
  const { data } = await api.get<TUserWebinarsResponse>(
    "/v1/users/me/webinars"
  );
  return data;
};

export const getWebinarAccessStatus = async (
  webinarId: number
): Promise<TWebinarAccessStatus> => {
  const { data } = await api.get<TWebinarAccessStatus>(
    `/v1/users/me/webinars/${webinarId}/status`
  );
  return data;
};

export const extendWebinarAccess = async (webinarId: number) => {
  const { data } = await api.post<TUserWebinar>(
    `/v1/users/me/webinars/${webinarId}/extend`
  );
  return data;
};

/**
 * Calculate countdown timer based on webinar deadline
 * @param deadline - The deadline timestamp after which access expires
 * @returns Target date for countdown (the access deadline)
 */
export const calculateCountdownTarget = (deadline: string): Date => {
  return new Date(deadline);
};

/**
 * Check if access has expired (deadline has passed)
 * @param deadline - The access deadline timestamp
 * @returns true if the deadline has passed
 */
export const isCountdownExpired = (deadline: string): boolean => {
  const deadlineDate = new Date(deadline);
  const currentDate = new Date();
  return currentDate.getTime() >= deadlineDate.getTime();
};
